import { of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';

import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';

import { AppState } from '../../../core.state';
import { NotificationService } from '../../../notifications/notification.service';
import {
    BaseNotificationsActionTypes, LoadBaseNotifications, LoadBaseNotificationsFail,
    SetBaseNotificationsAsRead
} from '../base-notification/base-notification.actions';
import {
    NotificationCertificationService
} from '../certification/notification-certification.service';
import {
    NotificationPublicHealthRecordService
} from '../public-health-record/notification-public-health-record.service';
import {
    DocumentNotificationsActionTypes, LoadCertificationNotifications,
    LoadCertificationNotificationsFail, LoadCertificationNotificationsSuccess,
    LoadPublicHealthRecordNotifications, LoadPublicHealthRecordNotificationsFail,
    LoadPublicHealthRecordNotificationsSuccess, SetCertificationNotificationAsRead,
    SetCertificationNotificationAsReadFail, SetCertificationNotificationAsReadSuccess,
    SetPublicHealthRecordNotificationAsRead, SetPublicHealthRecordNotificationAsReadFail,
    SetPublicHealthRecordNotificationAsReadSuccess
} from './document-notifications.actions';

@Injectable()
export class DocumentNotificationsEffects {


    constructor(
        private notificationCertificationService: NotificationCertificationService,
        private publicHealthRecordService: NotificationPublicHealthRecordService,
        private actions$: Actions,
        private store: Store<AppState>,
        private translateService: TranslateService,
        private location: Location,
        private notificationService: NotificationService
    ) {
    }

    @Effect({ dispatch: false })
    genericFail$ = this.actions$.pipe(
        ofType<Action & { payload: string }>(
            DocumentNotificationsActionTypes.LoadCertificationNotificationsFail,
            DocumentNotificationsActionTypes.LoadPublicHealthRecordNotificationsFail,
        ),
        tap(action => this.notificationService.error(action.payload))
    );

    @Effect()
    loadDocumentNotifications$ = this.actions$.pipe(
        ofType<LoadBaseNotifications>(BaseNotificationsActionTypes.LoadBaseNotifications),
        mergeMap((action) => {
            if (action instanceof LoadCertificationNotifications) {
                return this.notificationCertificationService.getAll().pipe(
                    map(items => {
                        // items.map(item => item.isCertification = true);
                        return new LoadCertificationNotificationsSuccess(items);
                    }),
                    catchError(err => of(new LoadCertificationNotificationsFail(err)))
                );
            }
            if (action instanceof LoadPublicHealthRecordNotifications) {
                return this.publicHealthRecordService.getAll().pipe(
                    map(items => {
                        return new LoadPublicHealthRecordNotificationsSuccess(items);
                    }),
                    catchError(err => of(new LoadPublicHealthRecordNotificationsFail(err)))
                );
            }
            return of(new LoadBaseNotificationsFail('Invalid action type'));
        }
        )
    );

    @Effect()
    setDocumentNotificationAsRead$ = this.actions$.pipe(
        ofType<SetBaseNotificationsAsRead>(BaseNotificationsActionTypes.SetBaseNotificationsAsRead),
        mergeMap((action) => {
            if (action instanceof SetCertificationNotificationAsRead) {
                return this.notificationCertificationService.setAsRead(action.id).pipe(
                    map(item => {
                        // item.isCertification = true;
                        return new SetCertificationNotificationAsReadSuccess(item);
                    }),
                    catchError(err => of(new SetCertificationNotificationAsReadFail(err)))
                );
            }
            if (action instanceof SetPublicHealthRecordNotificationAsRead) {
                return this.publicHealthRecordService.setAsRead(action.id).pipe(
                    map(item => {
                        return new SetPublicHealthRecordNotificationAsReadSuccess(item);
                    }),
                    catchError(err => of(new SetPublicHealthRecordNotificationAsReadFail(err)))
                );
            }
            return of(new LoadBaseNotificationsFail('Invalid action type'));
        }
        )
    );
}
